var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('ErrorScene',{attrs:{"code":"403","description":"抱歉！当前账号暂无访问权限，请联系管理员或切换账号后重试！","primary-text":"重新登录","primary-icon":"el-icon-switch-button","badge-text":"受限","compact":""},on:{"primary":_vm.goLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }